import { createAction, props } from '@ngrx/store';
import { CaseState } from '../../interfaces/interfaces';

export const saveServiceInformations = createAction(
  '[Case] Save Case Service Informations Case',
  props<{ caseObj: any }>()
);
export const saveServiceInformationsSuccess = createAction(
  '[Case] Save Case Service Informations Case Success',
  props<{ data: any }>()
);
export const saveServiceInformationsFailure = createAction(
  '[Case] Save Case Service Informations Case Failure',
  props<{ error: string }>()
);

export const setServiceInformationSuccess = (
  state: CaseState,
  { data }: { data: any }
) => {
  return {
    ...state,
    case: {
      ...state.case,
      serviceInformations: {
        lastPrice: data?.lastPrice ?? null,
        bottomDiscountPrice: data?.bottomDiscountPrice ?? null,
        bottomDiscountDescription: data?.bottomDiscountDescription ?? null,
        totalDiscountPrice: data?.totalDiscountPrice ?? null,
        totalProvisionPrice: data.totalProvisionPrice ?? null,
        totalPrice: data.totalPrice ?? null,
        provisionDescription: data?.provisionDescription ?? null,
        provisionInstitution: data?.provisionInstitution?.id ?? null,
        provisionNo: data?.provisionNo ?? null,
        numberOfServices: data?.numberOfServices ?? null,
        services:
          data?.serviceInformations?.map((s:any) => {
            return {
              serviceCode:s?.serviceCode ?? null,
              serviceName:s?.serviceName ?? null,
              serviceId:s?.serviceId ?? null,
              gatePrice:s?.gatePrice ?? null,
              memberPrice:s?.memberPrice ?? null,
              quantity:s?.quantity ?? null,
              totalPrice:s?.totalPrice ?? null,
              unitPrice:s?.unitPrice ?? null,
              lastPrice:s?.lastPrice ?? null,
              priceType:s?.priceType ?? null,
              ruleOfPopups:s?.ruleOfPopups ?? null,
              givenForFree:s?.givenForFree ?? null,
              discount: {
                percentage: s?.discountPercentage ?? null,
                price: s?.discountPrice ?? null,
              },
              bottomDiscount: {
                percentage: s?.bottomDiscountPercentage ?? null,
                price: s?.bottomDiscountPrice ?? null,
                description: s?.bottomDiscountDescription ?? null
              },
              provision: {
                percentage: s?.provisionPercentage ?? null,
                price: s?.provisionPrice ?? null,
              },
              flexiblePrice: {
                isFlexible: s?.flexiblePriceIsFlexible ?? false,
                price: s?.flexiblePricePrice ?? null,
              },
            };
          }) ?? [],
      },
      id: data?.id,
      caseType: data?.caseType,
      caseNo: data?.caseNo,
      createdAt: data?.createdAt ?? null,
      caseStatus: data?.caseStatus,
      appointmentStatus: data?.appointmentStatus,
      recordType:data?.recordType ?? null,
      appointmentStartDate:data?.appointmentStartDate ?? null,
      appointmentEndDate:data?.appointmentEndDate ?? null,
      uid:data?.uid ?? null,
      appointmentDuration:data?.appointmentDuration ?? null,
      cancelReason:data?.cancelReason?.valueObject?.id?.value ?? null,
      cancelDescription:data?.cancelDescription ?? null,
      isCaseApproved:data?.isCaseApproved ?? null,
      caseDate: data?.caseDate,
      plannedVehicle:data?.plannedVehicle ?? null,
      plannedStaff:data?.plannedStaff ?? null,
      childAppointments: data?.childAppointments ?? state.case.childAppointments ?? [],
      parentAppointment: data?.parentAppointment ?? state.case.parentAppointment ?? null,
      parentAppointmentId: data?.parentAppointmentId ?? state.case.parentAppointmentId ?? null,

      },
    loading: false,
    error: null,
  };
};
